// #region imports

// --- HS Code
import { AddCommand } from "./add-command";
import { DeleteCommand } from "./delete-command";
import { UpdateCommand } from "./update-command";

// #endregion

export interface CommandCollection<TTarget> {
  addCommands: AddCommand<TTarget>[];
  deleteCommands: DeleteCommand<TTarget>[];
  updateCommands: UpdateCommand<TTarget>[];
}
